import { useCallback } from 'react';
import { clearSessionStorage } from 'lib/auth/token-store';
import { queryClient } from 'lib/tanstack-query-client';

/**
 * Tears down everything tied to the signed-in customer: cached queries, the
 * stored tokens, the cart and any in-progress reservation.
 *
 * Shared by the navbar's sign-out button and by account deletion, which has to
 * leave the client in exactly the same state once the account is gone.
 */
export function useSignOut() {
  return useCallback(() => {
    queryClient.clear();
    clearSessionStorage();
  }, []);
}